(() => {
  const init = () => document.querySelectorAll('.ps-five-order').forEach(root => {
    if(root.dataset.prelanderSticky) return;
    root.dataset.prelanderSticky = 'true';
    const add = root.querySelector('[data-add]'), sticky = root.querySelector('[data-sticky-add]'), modal = root.querySelector('[data-modal]');
    if(!add || !sticky) return;
    const sync = () => {
      const rect = add.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;
      root.classList.toggle('ps-five-sticky-active',window.scrollY > 150 && !inView && !modal?.open);
    };
    new IntersectionObserver(sync,{threshold:0}).observe(add);
    window.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    if(modal) {new MutationObserver(sync).observe(modal,{attributes:true,attributeFilter:['open']});}
    sync();
    const reviews = document.querySelector('.ps-ugc');
    if(reviews) reviews.id='pen-cro-reviews';
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
